import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What's included in the personal chef service?",
    a: "Menu design, grocery and seafood sourcing, all cooking in your kitchen, plating and service throughout the meal, and full clean-up. You provide the kitchen; Kristy brings the rest.",
  },
  {
    q: "Do you accommodate dietary restrictions and allergies?",
    a: "Absolutely. Kristy regularly cooks gluten-free, dairy-free, pescatarian, vegan and vegetarian menus, along with allergy-safe adaptations. Just share the details when you inquire.",
  },
  {
    q: "Which islands do you serve?",
    a: "Nassau, Paradise Island, Eleuthera, Harbour Island, Exuma, and private yacht charters across the Bahamas. Travel to other Out Islands is available on request.",
  },
  {
    q: "How far in advance should I book?",
    a: "Two to four weeks is ideal for weekend and holiday dates. Shorter notice is often possible mid-week — always send an inquiry, and Kristy will confirm availability within 24 hours.",
  },
  {
    q: "What does it cost?",
    a: "Every event is custom-quoted based on guest count, courses, sourcing needs and travel. Send your date and party details for a same-week quote.",
  },
  {
    q: "Do you handle cocktails or wine pairings?",
    a: "Yes. Kristy can craft signature island cocktails and rum pairings, or coordinate wine pairings with your preferred sommelier or importer.",
  },
];

export default function FAQV2() {
  return (
    <section
      id="faq"
      data-testid="v2-faq-section"
      className="relative bg-[#F4F1EA] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4 md:sticky md:top-32 md:self-start">
          <div className="reveal flex items-center gap-3 mb-8">
            <span className="h-px w-8 bg-[#A94B37]" />
            <span className="font-mono-editorial text-[11px] text-[#A94B37]">
              05 · GOOD QUESTIONS
            </span>
          </div>
          <h2 className="reveal font-display font-light text-[#1A2B3C] leading-[1.02] text-4xl md:text-5xl tracking-tight">
            Everything
            <br />
            <span className="italic">before you ask.</span>
          </h2>
          <p className="reveal font-body text-[#3F4E5C] mt-6 text-base leading-relaxed">
            Can't find it here?{" "}
            <a
              href="#contact"
              className="text-[#A94B37] underline underline-offset-4 hover:text-[#C05A44]"
            >
              Ask Kristy directly →
            </a>
          </p>
        </div>

        <div className="md:col-span-8 reveal">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#1A2B3C]/15"
                data-testid={`v2-faq-${i}`}
              >
                <AccordionTrigger className="font-display text-xl md:text-2xl text-[#1A2B3C] py-6 text-left hover:no-underline hover:text-[#A94B37]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-base text-[#3F4E5C] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
